import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { emailRegex, FormState, phoneRegex } from '@opu/utils';
import AxiosInstance from '../../../helpers/AxiosInstance';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

const useForm = () => {
  let history = useHistory();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);

  const createOpuUser = () => {
    setLoading(true);
    AxiosInstance.post('/opu-user', {
      firstName: formState.inputValues.firstName,
      lastName: formState.inputValues.lastName,
      gender: formState.inputValues.gender,
      email: formState.inputValues.email,
      phone: formState.inputValues.phone,
      role: formState.inputValues.role,
    })
      .then((res) => {
        Swal.fire(t('opu-user.SUCCESS_CREATE_OPU_USER'), '', 'success');
        resetFormState();
        setLoading(false);
      })
      .catch((error) => {
        if (error.status === 400) {
          handleErrorsServer(error.data.message);
        } else Swal.fire(t('opu-user.ERROR_CREATE_OPU_USER'), '', 'error');
        setLoading(false);
      });
  };

  const inputValues = {
    firstName: { value: '', validate: { required: true } },
    lastName: { value: '', validate: { required: true } },
    email: { value: '', validate: { required: true, pattern: emailRegex } },
    phone: { value: '', validate: { required: true, pattern: phoneRegex } },
    gender: { value: '', validate: { required: true } },
    role: { value: '', validate: { required: true } },
  };

  const back = () => {
    history.goBack();
  };

  const { formState, submitHandler, resetFormState, field, handleErrorsServer } = FormState(inputValues, createOpuUser);

  return {
    submitHandler,
    resetFormState,
    loading,
    field,
    back,
  };
};

export default useForm;
